<div class="expense-rows-wrap">
    <div class="expense-rows-loading" *ngIf="loading">...</div>
    <div class="expense-rows-error" *ngIf="!loading && error">
        <span translate>column.approvals.expenseRowsLoadError</span>: {{ error }}
    </div>
    <ng-container *ngIf="!loading && !error">
        <que-approval-expense-row
            *ngFor="let row of rows"
            [row]="row"
            [canEdit]="canEdit"
            [approvalId]="approvalId"
            (rowClick)="rowClick.emit()">
        </que-approval-expense-row>
        <div class="expense-rows-empty" *ngIf="!rows?.length" translate>column.approvals.noExpenseRows</div>
    </ng-container>
</div>
